export default __webpack_public_path__ + "static/media/copy-to-clipboard.331725bb.svg";